<template>
	<div style="background-color:#FFF">
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100 text-center">
				<h3 class="order-title" style="padding: 30px 0">តារាងបង់ប្រាក់ {{ loan.name_khmer }}</h3>
			</div>

			<div class="md-layout-item md-small-size-50 md-size-50">
				<h3 class="order-title" style="padding: 10px 0;margin-left:50px; text-align: center;">ព័ត៌មានការកម្ចី</h3>
				<table style="margin-left: 50px">
					<tr>
						<td>ទឹកប្រាក់កម្ចី</td>
						<td>:</td>
						<td>{{config.moneylify(loan.amount)}}</td>
					</tr>
					<tr>
						<td>ការប្រាក់</td>
						<td>:</td>
						<td>{{config.moneylify(loan.interest_amount)}}</td>
					</tr>
					<tr>
						<td>រយៈពេលកម្ចី</td>
						<td>:</td>
						<td>{{loan.term}} ខែ</td>
					</tr>
					<tr>
						<td>ថ្ងៃចាប់ផ្តើមកម្ចី</td>
						<td>:</td>
						<td>{{config.datelify(loan.start_date)}}</td>
					</tr>
					<tr>
						<td>ថ្ងៃបញ្ចប់កម្ចី</td>
						<td>:</td>
						<td>{{config.datelify(loan.end_date)}}</td>
					</tr>
					<tr>
						<td>ទឹកប្រាក់បង់ខែដំបូង</td>
						<td>:</td>
						<td>{{config.moneylify(loan.initial_payment)}}</td>
					</tr>
					<tr>
						<td>ទឹកប្រាក់បង់ប្រចាំខែ</td>
						<td>:</td>
						<td>{{config.moneylify(loan.monthly_payment)}}</td>
					</tr>
					<tr>
						<td>ទឹកប្រាក់បង់ខែបញ្ចប់</td>
						<td>:</td>
						<td>{{config.moneylify(loan.final_payment)}}</td>
					</tr>
					<tr>
						<td>ចំនួនខែត្រូវបង់</td>
						<td>:</td>
						<td>{{loan.term}} ខែ</td>
					</tr>
					<tr>
						<td>ទឹកប្រាក់កម្ចីសរុប</td>
						<td>:</td>
						<td>{{config.moneylify(loan.amount+loan.interest_amount)}}</td>
					</tr>

				</table>
			</div>
			<div class="md-layout-item md-small-size-50 md-size-50">
				<h3 class="order-title" style="padding: 10px 0; text-align: center;">ព័ត៌មានការបង់ប្រាក់</h3>
				<table>
					<tr>
						<td>ABA Number</td>
						<td>:</td>
						<td>003 149 580</td>
					</tr>
					<tr>
						<td>ABA Name</td>
						<td>:</td>
						<td>SOY VICHETH AND SOK VUTTHY</td>
					</tr>

				</table>
			</div>
			<!-- <img src="@/assets/img/logo-black.jpg" class="print-logo"> -->
			<div class="md-layout-item md-small-size-100 md-size-100">
				<!-- <md-table v-if="paymentList.length > 0" style="margin-top: 30px;">
					<md-table-row class="no-hover">
						<md-table-cell style="text-align: center;">ល.រ</md-table-cell>
						<md-table-cell style="text-align: center;">លេខកូដ</md-table-cell>
						<md-table-cell style="text-align: center;">ថ្ងៃបង់ប្រាក់</md-table-cell>
						<md-table-cell style="text-align: center;">ការប្រាក់</md-table-cell>
						<md-table-cell style="text-align: center;">ប្រាក់ដើមនៅសល់</md-table-cell>
						<md-table-cell style="text-align: center;display:flex; justify-content: center;align-items: center;">
							ទឹកប្រាក់ត្រូវបង់ប្រចាំខែ</md-table-cell>
					</md-table-row>

					<md-table-row  class="no-hover" v-for="(payment, index) in paymentList">
						<md-table-cell style="text-align: center;">{{ payment.term_id }}</md-table-cell>
						<md-table-cell style="text-align: center;">{{ payment.hash_id }}</md-table-cell>
						<md-table-cell style="text-align: center;">{{ config.datelify(payment.created_date) }}</md-table-cell>
						<md-table-cell style="text-align: center;">{{ config.moneylify(payment.interest) }}</md-table-cell>
						<md-table-cell style="text-align: center;">{{ config.moneylify(payment.balance) }}</md-table-cell>
						<md-table-cell style="text-align: center;display:flex; justify-content: center;align-items: center;">
							<b>{{ config.moneylify(payment.interest + payment.principal)}}</b></md-table-cell>
					</md-table-row>
				</md-table> -->
				<table v-if="paymentList.length > 0"
					style="border-collapse: collapse; width: calc(100% - 100px);border:1px solid black;margin: 10px 50px 0 50px">
					<tr style="border: 1px solid black;padding: 5px">
						<td style="border: 1px solid black;padding: 5px;text-align: center;">ល.រ</td>
						<td style="border: 1px solid black;padding: 5px;text-align: center;">លេខកូដ</td>
						<td style="border: 1px solid black;padding: 5px;text-align: center;">ថ្ងៃបង់ប្រាក់</td>
						<td style="border: 1px solid black;padding: 5px;text-align: center;">ទឹកប្រាក់</td>
						<td style="border: 1px solid black;padding: 5px; text-align: center">ទឹកប្រាក់ត្រូវបង់ប្រចាំខែ</td>
						<td style="border: 1px solid black;padding: 5px;text-align: center;">សមតុល្យទឹកប្រាក់</td>
						<td style="border: 1px solid black;padding: 5px; text-align: center">ផ្សេងៗ</td>
					</tr>
					<tr v-for="(payment, index) in paymentList" style="border: 1px solid black">
						<td style="border: 1px solid black; text-align: center;padding: 5px">{{ payment.term_id }}</td>
						<td style="border: 1px solid black; text-align: center;padding: 5px">{{ payment.hash_id }}</td>
						<td style="border: 1px solid black; text-align: center;padding: 5px">{{
							config.datelify(payment.created_date) }}</td>
						<td style="border: 1px solid black; text-align: center;padding: 5px">{{
							config.moneylify(payment.currentTotal) }}</td>
						<td style="border: 1px solid black;text-align: center;padding: 5px">{{
							config.moneylify(payment.interest + payment.principal)}}</td>
						<td style="border: 1px solid black;padding: 5px;text-align: center;">{{
							config.moneylify(payment.interestBalance) }}</td>
						<td style="border: 1px solid black;text-align: center;padding: 5px"></td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<!-- <md-table>
					<md-table-row class="no-hover">
						<md-table-cell style="text-align: center;">ស្នាមមេដៃម្ចាស់កម្ចី</md-table-cell>
						<md-table-cell style="text-align: center;display:flex; justify-content: center;align-items: center;">
							ស្នាមមេដៃកូនកម្ចី</md-table-cell>
					</md-table-row>
					<md-table-row class="no-hover">
						<md-table-cell style="text-align: center;height: 100px"></md-table-cell>
						<md-table-cell style="text-align: center;height: 100px"></md-table-cell>
					</md-table-row>
					<md-table-row class="no-hover">
						<md-table-cell style="text-align: center;">សុខ វុទ្ធី</md-table-cell>
						<md-table-cell style="text-align: center;display:flex; justify-content: center;align-items: center;">
							{{ loan.name_khmer }}</md-table-cell>
					</md-table-row>
				</md-table> -->
				<table style="width:100%">
					<tr>
						<td class="center">ស្នាមមេដៃម្ចាស់កម្ចី</td>
						<td class="center">ស្នាមមេដៃកូនកម្ចី</td>
						<td class="center" v-for="guarantor in guarantorList">ស្នាមមេដៃអ្នកធានា</td>
					</tr>
					<tr style="height: 120px">
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td class="center">សុខ វុទ្ធី</td>
						<td class="center">{{ loan.name_khmer }}</td>
						<td class="center" v-for="guarantor in guarantorList">{{ guarantor.name_khmer }}</td>
					</tr>
				</table>
				<p class="text-center" style="margin-top: 50px">៣០នាទីក្រោយ បន្ទាប់ពីផ្តិតមេដៃ
					ទឹកប្រាក់នឹងបង្វិលចូលគណីរបស់លោកអ្នក..!!</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.getLoan();
		},
		mounted() { },
		data() {
			return {
				loaded: false,
				paymentList: [],
				guarantorList: [],
				loan: {
					id: "",
					hash_id: "",
					interest_amount: "",
					loan_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					name_khmer: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash_id).then(data => {
					this.loan = data.body.data
					this.$http.get(this.config.api + "/admin/loan/get_payment/" + this.$route.params.hash_id).then(data => {
						this.paymentList = data.body.data
						this.loaded = true
						this.$http.get(this.config.api + "/admin/loan/get_guarantor/" + this.$route.params.hash_id).then(data => {
							this.guarantorList = data.body.data
							setTimeout(() => {
								window.print();
							}, 1000)
						})
					})

				})
			},
		}
	}
</script>

<style>
	.no-hover:hover {
		background-color: #FFF !important;
	}
	.center {
		text-align: center;
	}

	body {
		background-color: #FFF !important;
	}

	.print-logo {
		height: 100px !important;
		margin: 16px;
	}

	.order-title {
		margin-top: 0;
		margin-bottom: 0;
	}

	.product-thumbnail {
		width: 64px;
		height: 64px;
		margin-right: 13px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintLoan.vue